<template>
  <modal-template :title="'Compartir'"
                  @close="$emit('closeShareModal')">
    <div class="social-modal-content">
      <social-sharing :url="url"
                      inline-template>
        <div class="social-modal-buttons">
          <network network="facebook"
                   class="facebook social-modal-button">
            <i class="facebook" />
            <span> {{ $t('socialShare.facebook') }}</span>
          </network>
          <network network="twitter"
                   class="twitter social-modal-button">
            <i class="twitter" />
            <span>Twitter</span>
          </network>
        </div>
      </social-sharing>
      <p class="social-modal-text"> {{ $t('socialShare.tambienPuedesCompartir') }}</p>
      <div class="posR container-share-button">
        <b-button id="social-modal-share"
                  class="transparent social-modal-share"
                  @click="copyToClipBoard"> {{ $t('socialShare.compartir') }}</b-button>
        <div class="tooltip fade bs-tooltip-top"
             role="tooltip"
             tabindex="-1"
             :class="{'show': showTooltip}">
          <div class="arrow" />
          <div class="tooltip-inner">
            <div>
              {{ $t('socialShare.copiado') }}</div>
          </div>
        </div>
      </div>
    </div>
  </modal-template>
</template>

<script>
import ModalTemplate from '@/components/modal-template/ModalTemplate.vue'

export default {
  components: {
    ModalTemplate
  },
  props: {
    url: {
      type: String,
      default: undefined
    }
  },
  data() {
    return {
      showTooltip: false
    }
  },
  methods: {
    copyToClipBoard: function() {
      if (navigator && navigator.clipboard && navigator.clipboard.writeText)
        navigator.clipboard.writeText(this.url || window.location.href)
      this.showTooltip = true
      setTimeout(() => {
        this.showTooltip = false
      }, 2000)
    }
  }
}
</script>

<style lang="scss">
@import './social-share.sass';
</style>

